import GenuineParts from "@/app/components/PecasComponents/GenuineParts";
import FindParts from "@/app/components/PecasComponents/FindParts";
import ConsultParts from "@/app/components/PecasComponents/ConsultParts";
import { withServicesLayout } from "@/pages/_layoutService";

function Pecas() {
  return (
    <main className="min-h-screen">
      <GenuineParts />
      <FindParts />
      <ConsultParts />
    </main>
  );
}
export default withServicesLayout(Pecas);
export { getServerSideProps } from "@/pages/_layoutService";
